"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _theme = _interopRequireDefault(require("../styles/theme"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
}; // $FlowFixMe
/* istanbul ignore next */
var StyledButton = _styledComponents["default"].button.withConfig({
  displayName: "StyledButton",
  componentId: "sc-5vxujj-0"
})(["min-width:max-content;padding:10px;color:", ";background:transparent;border:0;word-wrap:break-word;font-family:Raleway;font-style:normal;font-weight:500;line-height:17px;font-size:16px;text-align:center;letter-spacing:0.5px;text-transform:uppercase;transition:all 0.3s ease;user-select:none;cursor:pointer;display:flex;&:focus{outline:none;}&:hover{color:", ";}&:active{color:", ";}", " ", " ", " ", ""], function (props) {
  return props.colors.color;
}, function (props) {
  return props.colors.hover;
}, function (props) {
  return props.colors.active;
}, function (props) {
  return props.outline && (0, _styledComponents.css)(["padding:10px 28px;border:1px solid ", ";border-radius:32px;&:hover{color:", ";border-color:", ";}&:active{color:", ";border-color:", ";}", ""], function (props) {
    return props.colors.color;
  }, function (props) {
    return props.colors.hover;
  }, function (props) {
    return props.colors.hover;
  }, function (props) {
    return props.colors.active;
  }, function (props) {
    return props.colors.active;
  }, function (props) {
    return props.disabled && (0, _styledComponents.css)(["color:", ";border-color:", ";pointer-events:none;"], _theme["default"].lightGrey, _theme["default"].lightGrey);
  });
}, function (props) {
  return props.fill && (0, _styledComponents.css)(["padding:10px 28px;color:white;background:", ";border:1px solid ", ";border-radius:32px;&:hover{color:white;background:", ";border-color:", ";}&:active{color:white;background:", ";border-color:", ";}", ""], function (props) {
    return props.colors.color;
  }, function (props) {
    return props.outline ? _theme["default"].white : props.colors.color;
  }, function (props) {
    return props.colors.hover;
  }, function (props) {
    return props.outline ? _theme["default"].white : props.colors.hover;
  }, function (props) {
    return props.colors.active;
  }, function (props) {
    return props.outline ? _theme["default"].white : props.colors.active;
  }, function (props) {
    return props.disabled && (0, _styledComponents.css)(["background:", ";border-color:", ";pointer-events:none;"], _theme["default"].lightGrey, _theme["default"].lightGrey);
  });
}, function (props) {
  return props.icon && (0, _styledComponents.css)(["padding:10px 24px;", ""], function (props) {
    return !props.title && (0, _styledComponents.css)(["padding:10px 11px;", "{margin-right:0;}", ""], IconContainer, function (props) {
      return !props.fill && !props.outline && (0, _styledComponents.css)(["padding:2px;border:none;background:none;"]);
    });
  });
}, function (props) {
  return props.padding && (0, _styledComponents.css)(["padding:", ";line-height:10px;"], props.padding);
});
StyledButton.displayName = 'StyledButton';
var IconContainer = _styledComponents["default"].div.withConfig({
  displayName: "IconContainer",
  componentId: "sc-5vxujj-1"
})(["margin-right:10px;"]);
IconContainer.displayName = 'IconContainer';
var Button = /*#__PURE__*/function (_React$Component) {
  _inherits(Button, _React$Component);
  var _super = _createSuper(Button);
  function Button() {
    var _this;
    _classCallCheck(this, Button);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "getIconFillColor", function () {
      var _this$props = _this.props,
        fill = _this$props.fill,
        disabled = _this$props.disabled;
      if (fill) {
        return _theme["default"].white;
      }
      if (disabled) {
        return _theme["default"].disabled;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getThemeColors", function () {
      var style = _this.props.style || 'info';
      switch (style) {
        case 'info':
          return {
            color: _theme["default"].info,
            active: _theme["default"].infoActive,
            hover: _theme["default"].infoHover
          };
        case 'success':
          return {
            color: _theme["default"].success,
            active: _theme["default"].successActive,
            hover: _theme["default"].successHover
          };
        case 'warning':
          return {
            color: _theme["default"].warning,
            active: _theme["default"].warningActive,
            hover: _theme["default"].warningHover
          };
        case 'error':
          return {
            color: _theme["default"].danger,
            active: _theme["default"].dangerActive,
            hover: _theme["default"].dangerHover
          };
        case 'lightGray':
          return {
            color: _theme["default"].lightGrey,
            active: _theme["default"].lightGrey,
            hover: _theme["default"].lightGrey
          };
        default:
          return {
            color: _theme["default"].info,
            active: _theme["default"].infoActive,
            hover: _theme["default"].infoHover
          };
      }
    });
    return _this;
  }
  _createClass(Button, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        onClick = _this$props2.onClick,
        fill = _this$props2.fill,
        outline = _this$props2.outline,
        disabled = _this$props2.disabled,
        icon = _this$props2.icon,
        title = _this$props2.title,
        padding = _this$props2.padding,
        size = _this$props2.size,
        testID = _this$props2.testID;
      var colors = this.getThemeColors();
      return /*#__PURE__*/_react["default"].createElement(StyledButton, {
        onClick: onClick,
        fill: fill,
        outline: outline,
        disabled: disabled,
        icon: icon,
        title: title,
        padding: padding,
        colors: colors,
        "data-cy": testID || 'Button'
      }, this.props.icon && /*#__PURE__*/_react["default"].createElement(IconContainer, null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        iconName: icon,
        size: size || '1x',
        color: this.getIconFillColor
      })), this.props.title);
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    value: // @ts-ignore
    function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return Button;
}(_react["default"].Component);
var _default = Button;
var _default2 = _default;
exports["default"] = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(StyledButton, "StyledButton", "/Users/crs/WebstormProjects/michelangelo/src/Components/Buttons/Button.js");
  reactHotLoader.register(IconContainer, "IconContainer", "/Users/crs/WebstormProjects/michelangelo/src/Components/Buttons/Button.js");
  reactHotLoader.register(Button, "Button", "/Users/crs/WebstormProjects/michelangelo/src/Components/Buttons/Button.js");
  reactHotLoader.register(_default, "default", "/Users/crs/WebstormProjects/michelangelo/src/Components/Buttons/Button.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();